import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ResumenDashboardProyectos } from "src/app/dashboard/pestanas/proyectos/proyectos-dashboard.model";
import { sinSelloDeError } from "src/app/shared/http/sello-de-error";
import { ConsultaList } from "src/app/shared/model/core/ConsultaList.model";
import { RangoPeriodo } from "src/app/dashboard/shared/dashboard-graficas";
import { UrlConstantes } from "src/app/utilerias/constantes/urlconstantes";

/**
 * Servicio local de la pestaña Proyectos del Dashboard de Inicio: un solo
 * endpoint que trae totales, graficas y ranking. Es un bean (no un
 * ConsultaList), asi que el error viene en las cabeceras COD_STATUS /
 * MESSAGE y sinSelloDeError lo vuelve un error de rxjs.
 */
@Injectable({
  providedIn: "root",
})
export class ProyectosDashboardService {
  constructor(private http: HttpClient) {}

  /**
   * @param rango periodo "yyyy-MM-dd"; solo acota la grafica de creados
   *        por mes, el resto es foto de hoy. Va como param1/param2 de un
   *        ConsultaList, que es la envoltura de la casa.
   */
  resumen(rango: RangoPeriodo): Observable<ResumenDashboardProyectos> {
    const req = new ConsultaList<unknown>();
    req.param1 = rango.inicio;
    req.param2 = rango.fin;
    return this.http
      .post<ResumenDashboardProyectos>(UrlConstantes.PROYECTOS_DASHBOARD, req, { observe: "response" })
      .pipe(sinSelloDeError<ResumenDashboardProyectos>("No se pudo consultar el dashboard de proyectos."));
  }
}
